import { createFileRoute } from '@tanstack/react-router';

import { ReadAlongPage } from '@/components/start/read-along/read-along-page';
import { Schema } from 'effect';
import { optionalCatching } from '@/lib/search-params';

/** `?note=<id>` opens the document at that note — see `useLoadAudioFromSlug`. */
const ReadAlongSearch = Schema.Struct({
  note: optionalCatching(Schema.String),
});

export const Route = createFileRoute(
  '/app/_authenticated/_dashboard/readalong/$audioIdOrSlug',
)({
  component: Page,
  validateSearch: Schema.toStandardSchemaV1(ReadAlongSearch),
});

function Page() {
  const { audioIdOrSlug } = Route.useParams();
  const { note } = Route.useSearch();
  return <ReadAlongPage slug={audioIdOrSlug} noteId={note} />;
}
